import React from 'react';

interface RatingChartProps {
  ratings: {
    category: string;
    score: number;
  }[];
}

const RatingChart: React.FC<RatingChartProps> = ({ ratings }) => {
  return (
    <div className="space-y-4">
      {ratings.map((rating, index) => (
        <div key={index}>
          <div className="flex justify-between mb-2">
            <span className="font-semibold">{rating.category}</span>
            <span className="text-accent-primary font-bold">{rating.score}/10</span>
          </div>
          <div className="w-full bg-dark-card rounded-full h-3 overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-accent-primary to-accent-secondary rounded-full transition-all duration-1000"
              style={{ width: `${rating.score * 10}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default RatingChart;

